import { gql } from '@apollo/client'

export const CREATE_ROUTE_V2 = gql`
  mutation CreateTRoute($input: CreateTRouteInput!) {
    createTRoute(input: $input) {
      id
    }
  }
`

export const CHANGE_ROUTE = gql`
  mutation ChangeRoute($id: UUID!, $input: ChangeTRouteInput!) {
    changeTRoute(id: $id, input: $input)
  }
`
